import React from 'react';
import './MessageBox.styl';
import {getMuiV4Theme} from 'utils/css/themeUtils';

/** Simple message boxes that display a text message with a non-transparent background for the users to see */
class MessageBox extends React.Component {
  render() {
    const style = this.props.style ?? {};
    const divStyle = {
      backgroundColor: getMuiV4Theme().palette.primary.main,
      ...style,
    };
    return (
      <div className="messageBox" style={divStyle}>
        <p>{this.props.message}</p>
      </div>
    );
  }
}

export default MessageBox;
